import { render, staticRenderFns } from "./SelectorPopup.vue?vue&type=template&id=90b298b4&scoped=true"
import script from "./SelectorPopup.vue?vue&type=script&lang=js"
export * from "./SelectorPopup.vue?vue&type=script&lang=js"
import style0 from "./SelectorPopup.vue?vue&type=style&index=0&id=90b298b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b298b4",
  null
  
)

export default component.exports